import { UserDto } from "../types/dto";

export const UserNameWithEmail = ({ firstName, lastName, email }: UserDto) => {
	const emailStr = email ? `<${email?.toLowerCase()?.trim()}>` : "";
	let nameStr = null;
	if (firstName) {
		nameStr = `${firstName?.trim() || ""} ${lastName?.trim() || ""}`;
	} else if (email) {
		nameStr = <span className="text-danger">Pending user activation</span>;
	}

	return (
		<span data-testid="test-userNameWithEmail">
			{nameStr} {emailStr}
		</span>
	);
};
